import React from "react";
import styled from "styled-components";
import * as ContextMenu from "@radix-ui/react-context-menu";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";

/* ------------------------------------------------------------- */
/* --------------------- ContextMenu.Item ---------------------- */
/* ------------------------------------------------------------- */

const StyledContextMenuItem = styled(ContextMenu.Item)`
    display: flex;
    gap: 10px;
    padding: 10px;

    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.normal};
    cursor: pointer;

    &[data-highlighted] {
        background-color: ${(props) => props.theme.hoverPrimary};
        outline: none;
    }

    &[data-disabled] {
        color: ${(props) => props.theme.textColorSecondary};
        background-color: ${(props) => props.theme.backgroundSpecial};
        cursor: not-allowed;
    }
`;

interface ContextMenuItemProps {
    readonly children: React.ReactNode[] | React.ReactNode;
    readonly onClick: () => void;
    readonly disabled?: boolean;
}
export function ContextMenuItem(props: ContextMenuItemProps) {
    return (
        <StyledContextMenuItem onClick={props.onClick} disabled={props.disabled}>
            {props.children}
        </StyledContextMenuItem>
    );
}

/* ------------------------------------------------------------- */
/* -------------- ContextMenuComponents.Content ---------------- */
/* ------------------------------------------------------------- */
/* - Note: this component must be used with -------------------- */
/* - ContextMenuComponents.Root & ContextMenuComponents.Trigger  */
/* ------------------------------------------------------------- */

const StyledContextContent = styled(ContextMenu.Content)`
    padding: unset;
    margin: 5px;
    border-radius: ${Styles.borderRadiusSharp};
    background-color: ${(props) => props.theme.backgroundPrimary};
    overflow: scroll;

    min-width: 250px;
    width: fit-content;
    box-shadow: ${(props) => props.theme.boxShadow} ${(props) => props.theme.boxShadowColor};
`;
interface ContextMenuContentProps {
    readonly children: React.ReactNode[] | React.ReactNode;
}
export function ContextMenuContent(props: ContextMenuContentProps) {
    const portalDiv = document.getElementById("dropdown-portal");

    return (
        <ContextMenu.Portal container={portalDiv}>
            <StyledContextContent>{props.children}</StyledContextContent>
        </ContextMenu.Portal>
    );
}

export const ContextMenuComponents = {
    Root: ContextMenu.Root,
    Trigger: ContextMenu.Trigger,
    Item: ContextMenuItem,
    Content: ContextMenuContent,
};
